import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsNotEmpty, IsString } from 'class-validator'

export class CreateBillingProfileRequest {
	@ApiProperty({ type: String, format: 'uri' })
	@IsNotEmpty()
	@IsString()
	refreshUrl: string

	@ApiProperty({ type: String, format: 'uri' })
	@IsNotEmpty()
	@IsString()
	redirectUrl: string
}

export class CreateBillingProfileResponse {
	@ApiProperty({ type: String, format: 'uri' })
	redirectUrl: string

	@ApiProperty({ type: String })
	accountId: string
}

export class ExternalAccountResponse {
	@ApiPropertyOptional({ type: String })
	accountHolderName?: string

	@ApiPropertyOptional({ type: String })
	bankName?: string

	@ApiPropertyOptional({ type: String })
	currency?: string

	@ApiPropertyOptional({ type: Boolean })
	default_for_currency?: boolean

	@ApiPropertyOptional({ type: String })
	routing_number?: string

	@ApiPropertyOptional({ type: String })
	last4?: string
}

export class BillingProfileResponse {
	@ApiProperty({ type: String })
	accountId: string

	@ApiPropertyOptional({ type: Boolean })
	detailsSubmitted?: boolean

	@ApiPropertyOptional({ type: ExternalAccountResponse })
	account?: ExternalAccountResponse
}
